import T from '@data/text/myHealthTexts.json';

export const getRiskLevelName = (level: string) => {
  const nameMap: Record<string, string> = T.risksSection.riskLevelNames as Record<string, string>;
  return nameMap[level] || level;
};

export const riskCodeToIcon: Record<string, string> = {
  immune_deficiency: 'icon-9',
  reproductive: 'icon-gynecology-2',
  cardio: 'icon--3',
  nervous: 'icon-woman',
  digestive: 'icon-8',
  bone_joint: 'icon--4',
  diabetes: 'icon-7',
  liver: 'icon--',
  kidney: 'icon--1',
  thyroid: 'icon---1',
  pancreas: 'icon---',
};

export const riskCodeToIconIngos: Record<string, string> = {
  immune_deficiency: 'icon-9-ingos',
  reproductive: 'icon-gynecology-2-ingos',
  cardio: 'icon--3-ingos',
  nervous: 'icon-woman-ingos',
  digestive: 'icon-8-ingos',
  bone_joint: 'icon--4-ingos',
  diabetes: 'icon-7-ingos',
  liver: 'icon---ingos',
  kidney: 'icon--1-ingos',
  thyroid: 'icon---1-ingos',
  pancreas: 'icon----ingos',
};

export const riskCodeToTitle: Record<string, string> =
  T.risksSection.riskCodeToTitle as Record<string, string>;
